<div class="row no-gutters mb-3" [formGroup]="formCalendar" [style]="{'flex-wrap':horizontal ? 'nowrap':'wrap', 'height': horizontal ? '38px':'' }">
    <div class="input-group" [style]="{'padding-bottom': horizontal ? '0px':'10px'}">
        <div class="input-group-prepend">
            <div class="input-group-text" style="width:55px">From</div>
        </div>
        <input id="dateFrom" name="dateFrom" class="form-control bg-white" type="text" ngbDatepicker #df="ngbDatepicker"
            [minDate]="minDate" [startDate]="toNgbDate(from)" [value]="formattedDateFrom" [navigation]="navigation"
            (click)="df.toggle()" (dateSelect)="onDateFromSelect($event)" [markDisabled]="isDateDisabled"
            readonly />
        <!-- value="September 1, 2021"   -->
    </div>
    <div class="input-group" [style]="{'padding-bottom': horizontal ? '0px':'10px'}">
        <div class="input-group-prepend">
            <div class="input-group-text" style="width:55px">To</div>
        </div>
        <input id="dateTo" name="dateTo" class="form-control bg-white" ngbDatepicker #dt="ngbDatepicker"
            [minDate]="minDateTo" [startDate]="toNgbDate(to)" [value]="formattedDateTo" [navigation]="navigation"
            (dateSelect)="onDateToSelect($event)" (click)="dt.toggle()" [maxDate]="maxDate" 
            [markDisabled]="isDateDisabled" readonly />
    </div>
</div>